var _style, _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpiryIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 185.22 173.93",
    style: {
      enableBackground: "new 0 0 185.22 173.93"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.expiry-icon.st0{fill:#EEEEEE;}\n\t.expiry-icon.st1{fill:#676767;}\n\t.expiry-icon.st2{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "expiry-icon st0",
    d: "M68.75,22.69c-27.15,0-49.24,22.09-49.24,49.24c2.7,65.33,95.79,65.31,98.48,0 C117.99,44.78,95.9,22.69,68.75,22.69z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "expiry-icon st1",
    d: "M68.75,130.29c-51.8-0.05-77.86-62.97-41.27-99.63c21.72-22.64,60.81-22.64,82.54,0 C146.61,67.33,120.55,130.24,68.75,130.29z M68.75,22.69c-27.15,0-49.24,22.09-49.24,49.24c2.7,65.33,95.79,65.31,98.48,0 C117.99,44.78,95.9,22.69,68.75,22.69z M89.99,86.71L75.58,72.31c0.13-2.13-0.78-4.16-2.27-5.48c0-0.05,0-0.1,0-0.14V40.01 c-0.24-6.05-8.88-6.04-9.12,0v26.67c0,0.05,0,0.1,0,0.14c-4.77,4.27-1.53,12.26,4.94,11.93l14.41,14.41c1.78,1.78,4.67,1.78,6.45,0 C91.77,91.38,91.77,88.49,89.99,86.71L89.99,86.71z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "expiry-icon st2",
    d: "M171.88,142.56L135.41,79.4c-5.96-10.43-21.02-10.43-26.95,0l-36.49,63.16c-5.96,10.43,1.46,23.4,13.48,23.4 h72.82C170.29,165.96,177.83,152.87,171.88,142.56z M121.91,151.94c-3.17,0-5.81-2.64-5.81-5.81c0-3.17,2.64-5.81,5.81-5.81 s5.81,2.64,5.68,5.96C127.74,149.31,124.96,151.94,121.91,151.94z M127.21,114.41c-0.26,4.5-0.54,8.98-0.79,13.48 c-0.13,1.46-0.13,2.79-0.13,4.22c-0.13,2.38-1.99,4.22-4.37,4.22s-4.22-1.71-4.37-4.09c-0.39-7.01-0.79-13.88-1.18-20.89 c-0.13-1.84-0.26-3.71-0.41-5.55c0-3.04,1.71-5.55,4.5-6.34c2.79-0.66,5.55,0.66,6.75,3.3c0.41,0.92,0.54,1.84,0.54,2.91 C127.61,108.6,127.33,111.52,127.21,114.41z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "expiry-icon st1",
    d: "M121.98,151.94c-3.17,0-5.81-2.64-5.81-5.81c0-3.17,2.64-5.81,5.81-5.81s5.81,2.64,5.68,5.96 C127.81,149.31,125.02,151.94,121.98,151.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "expiry-icon st1",
    d: "M127.27,114.41c-0.26,4.5-0.54,8.98-0.79,13.48c-0.13,1.46-0.13,2.79-0.13,4.22 c-0.13,2.38-1.99,4.22-4.37,4.22s-4.22-1.71-4.37-4.09c-0.39-7.01-0.79-13.88-1.18-20.89c-0.13-1.84-0.26-3.71-0.41-5.55 c0-3.04,1.71-5.55,4.5-6.34c2.79-0.66,5.55,0.66,6.75,3.3c0.41,0.92,0.54,1.84,0.54,2.91C127.68,108.6,127.4,111.52,127.27,114.41z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiryIcon);
export default __webpack_public_path__ + "static/media/expiry-icon.0eb4d7c63f152f39830e77ff31311ff0.svg";
export { ForwardRef as ReactComponent };